import { gql } from '@apollo/client';
import { ADDRESS_FRAGMENT } from '../fragments.rest';

export type DeleteAddressMutation = {
  deleteAddress: {
    data: null;
    __typename: 'RestDeleteAddress';
  };
};

export const DELETE_ADDRESS_MUTATION = gql`
  mutation DeleteAdressMutation($id: string) {
    deleteAddress(id: $id)
      @rest(
        type: "RestDeleteAddress"
        endpoint: "user"
        path: "/addresses/{args.id}"
        method: "DELETE"
      ) {
      data @type(name: "RestAddress") {
        ...AddressFragment
      }
    }
  }
  ${ADDRESS_FRAGMENT}
`;
